export default "__VITE_ASSET__aplqapZv__"